import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function OpeningHook() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-[var(--cream)] py-24 md:py-32" data-id="element-246">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.8
    }} className="max-w-2xl mx-auto px-6" data-id="element-247">
        <div className="space-y-6 text-[var(--charcoal)] text-lg md:text-xl leading-relaxed font-display" data-id="element-248">
          <p className="text-2xl md:text-3xl italic text-[var(--dusk-purple)]" data-id="element-249">
            Hay algo que probablemente nunca le dijiste a nadie.
          </p>

          <p data-id="element-250">
            Que te cansas de seguir. Que hay días en que sonríes por fuera
            mientras por dentro algo se está apagando lentamente. Que has leído
            libros, escuchado podcasts, ido a la iglesia, hecho promesas a Dios
            a medianoche... y aun así, esa sensación de vacío sigue ahí.
          </p>

          <p className="font-semibold" data-id="element-251">
            No estás loco. No estás roto más allá de la reparación.
          </p>

          <p data-id="element-252">Estás herido. Y nadie te ha dado el mapa correcto para salir.</p>

          <p data-id="element-253">
            Porque la mayoría de los libros de autoayuda te dicen que pienses
            positivo, que respires profundo, que "todo pasa por algo." Pero tú y
            yo sabemos que eso no alcanza cuando el dolor es real. Cuando lo que
            viviste no fue pequeño. Cuando el daño fue profundo.
          </p>

          <p className="text-2xl italic text-[var(--dusk-purple)] pt-6" data-id="element-254">
            Este libro no te va a decir que sonrías.
          </p>

          <p className="font-semibold" data-id="element-255">
            Te va a llevar al barro. A la herida. A la verdad.
          </p>

          <p className="text-xl italic" data-id="element-256">
            Porque solo cuando abrazas lo que te duele... puedes empezar a
            volar.
          </p>
        </div>
      </motion.div>
    </section>;
}